<template>
  <div>
    <v-container class="programa-page" fluid>
      <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
        <v-icon>mdi-arrow-left-bold</v-icon> Regresar 
      </v-btn>

      <ProgramaHero :programa="programa" :loading="loading" @guardar="guardarcambios" />

      <v-card :loading="loading" class="programa-card">
        <v-card-text class="programa-body">
          <form>
            <SeccionInfo
              :programa="programa"
              :sedes-filtradas="sedes_filtradas"
              :convenios="convenios"
              :universidadsel.sync="universidadsel"
              :coordinadorsel="coordinadorsel"
              :responsablesel="responsablesel"
              :proyectoasig="proyectoasig"
              :loadingproy="loadingproy"
              :only-read-acade="only_read_acade"
              :is-perm-benefi="is_perm_benefi"
              :archivo-portada.sync="archivoPortada"
              :archivo-certificado.sync="archivoCertificado"
              :portadasel="portadasel"
              :certificadosel="certificadosel"
              :cargandoportada="cargandoportada"
              :cargandocertificado="cargandocertificado"
              :subidores="subidores"
              :subidores1="subidores1"
              :location-portadas="location_programa_portadas"
              :location-certificados="location_certificado_programa"
              @imagen-select="imagenselect"
              @subir-imagen="subirimagen"
            />

            <SeccionModulos
              :modulos="programa.programa_modulo"
              :modulo-editando="moduloEditando"
              :dragged-modulo="draggedProgramaModulo"
              :tipos-calificacion="tiposCalificacion"
              :only-read-acade="only_read_acade"
              @cargar-modulos-universidad="cargar_modulos_universidad"
              @add-modulo="addnewmodulo"
              @editar-modulo="editarModulo"
              @guardar-modulo="guardarModulo"
              @cancelar-edicion="cancelarEdicion"
              @drag-start="handleDragStart"
              @drop="handleDrop"
              @drag-end="handleDragEnd"
              @open-edit-mod="openeditmod"
            />

            <SeccionPlanes
              :planes="programa.planes"
              :templates="templates"
              :conceptos="conceptos"
              :loadingtemplates="loadingtemplates"
              :only-read-conta="only_read_conta"
              @template-selected="onTemplateSelected"
              @aprobar-plan="aprobarplan"
              @agregar-plan="addnewplan(1)"
              @quitar-plan="addnewplan(0)"
              @agregar-concepto="addnewconcepto(1, $event)"
              @quitar-concepto="addnewconcepto(0, $event)"
              @redondear="redondearTwoDecimals"
            />

            <SeccionPostitulos
              :programa-id="programa.programa_id"
              :postitulos="postitulos"
              :postitulouni="postitulouni"
              :postitulodefaultuniv="postitulodefaultuniv"
              :loadingpostitulos="loadingpostitulos"
              :is-postgrado="ispostgrado"
              :only-read-acade="only_read_acade"
              @add-postitulo="addnewpostitulo"
            />

            <SeccionContabilidad
              :codigo-contabilidad.sync="codigo_contabilidad"
              :sucursal.sync="sucursal"
              :sucursales="sucursales"
              :matriz="matriz"
              :only-read-conta="only_read_conta"
              :mostrar-netsuite="mostrarNetsuite"
              :yaenvido-loading="yaenviado_loading"
              @guardar-codigo="onGuardarCodigo"
              @guardar-sucursal="saveFormSucursal"
              @abrir-netsuite="openModalNetsuiteConta"
            />
          </form>

          <!-- Resultado/mensaje -->
          <p class="text-center text-danger font-weight-bold mt-4">{{ msg }}</p>
        </v-card-text>

        <v-card-title v-if="programa && programa.nombre_compuesto" class="text-center primary--text">
          <v-spacer />
          {{ `${programa.nombre_compuesto.slice(0,1)}-${programa.programa_id}   ${programa.nombre_compuesto}` }}
          <v-spacer />
        </v-card-title>

        <div class="d-flex justify-center" v-if="universidadsel && universidadsel.id">
          <p class="blue--text text-center">
            Convenio: <b>({{ universidadsel.abreviatura }}) {{ universidadsel.nombre }}</b>
          </p>
          <v-btn v-if="UNIDAD_NEGOCIO_ID != 1" @click="universidadsel = null" x-small tile text color="red" outlined>
            Quitar convenio
          </v-btn>
        </div>

        <v-card-actions class="text-center">
          <v-spacer />
          <v-btn color="success" @click="guardarcambios()">Guardar cambios</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-container>

    <VerProyectos ref="verproyectos" v-on:proyectosel="asignarprogramaunsxx" />
    <NetSuiteConta ref="refNetSuiteConta" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import dataMixin from './mixins/dataMixin';
import modulosMixin from './mixins/modulosMixin';
import operacionesMixin from './mixins/operacionesMixin';
import ProgramaHero from './components/ProgramaHero.vue';
import SeccionInfo from './components/SeccionInfo.vue';
import SeccionModulos from './components/SeccionModulos.vue';
import SeccionPlanes from './components/SeccionPlanes.vue';
import SeccionPostitulos from './components/SeccionPostitulos.vue';
import SeccionContabilidad from './components/SeccionContabilidad.vue';
import VerProyectos from '@/views/sigloxx/verproyectos.vue';
import NetSuiteConta from '@/components/Programa-viewrestNetsuiteConta.vue';

export default {
  name: 'ProgramaViewrestEsam',
  components: { ProgramaHero, SeccionInfo, SeccionModulos, SeccionPlanes, SeccionPostitulos, SeccionContabilidad, VerProyectos, NetSuiteConta },
  mixins: [dataMixin, modulosMixin, operacionesMixin],

  data() {
    return {
      location_certificado_programa: process.env.VUE_APP_URL_CERT_PROGRAMAS,
      location_programa_portadas: process.env.VUE_APP_URL_PORTADAS,
      api_rest: process.env.VUE_APP_API_REST,
      loading: false,
      loadingtemplates: false,
      loadingpostitulos: false,
      loadingproy: false,
      cargandoportada: false,
      cargandocertificado: false,
      ispostgrado: false,
      modulos_obligatorios: false,
      isdevmode: false,
      subidores: false,
      subidores1: false,
      portadasel: true,
      certificadosel: true,
      archivoPortada: null,
      archivoCertificado: null,
      is_perm_benefi: false,
      only_read_acade: false,
      only_read_conta: false,
      msg: '',
      matriz: null,
      sedes: [],
      convenios: [],
      conceptos: [],
      templates: [],
      templatexsel: null,
      sucursal: null,
      sucursales: [],
      coordinadorsel: { idusuario: null },
      responsablesel: { idusuario: null },
      universidadsel: { iduniversidad: null },
      programa: { coordinador: {}, responsable: {}, programa_modulo: [], planes: [] },
      codigo_contabilidad: '',
      postitulos: [],
      postitulouni: { iduniversidad: null },
      postitulodefaultuniv: null,
      proyectosxx: null,
      proyectoasig: null,
      nomostrarproy: true,
      xposgradin: {},
      yaenviado: [],
      yaenviado_loading: false,
      draggedProgramaModulo: null,
      moduloEditando: null,
      moduloEditandoCopia: null,
      tiposCalificacion: [
        { value: 'Moodle', text: 'Moodle' },
        { value: 'Sistema', text: 'Sistema' },
        { value: 'Moodle y Sistema', text: 'Moodle y Sistema' },
      ],
      visibleDialogo: false,
      programasUniversidades: [],
      programaSeleccionado: { universidadId: null, programaUniversidadId: null, programaUniversidad: null },
      actualizandoPrograma: false,
      busqueda: null,
      retardo: null,
      formValid: true,
    };
  },

  computed: {
    ...mapState({ UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID }),
    sedes_filtradas() {
      const unidad = this.xposgradin.unidad_negocio_id || this.$store.state.CARGO.sede.unidad_negocio;
      return this.sedes.filter(item => item.unidad_negocio == unidad);
    },
    mostrarNetsuite() {
      const id = this.$store.state.CARGO.id;
      return id == 14 || id == 15 || id == 1;
    },
  },

  watch: {
    UNIDAD_NEGOCIO_ID() { this.getconceptosdepago(); },
    'universidadsel.id'() {
      if (this.UNIDAD_NEGOCIO_ID == 1) {
        if (!this.universidadsel || !this.universidadsel.id) {
          this.proyectosxx = null; this.nomostrarproy = false; return;
        }
      }
      if (this.programa.universidad_id && this.nomostrarproy) return;
    },
    '$store.state.convenio'() { this.universidadsel = this.$store.state.convenio; },
  },

  methods: {
    onTemplateSelected(template) {
      const plan = {
        tipo_plan_id: template.tipo_plan_id,
        aprobado: false, estado: true, nombre: template.nombre, xedit: false, cobros: [],
      };
      template.conceptos.forEach(x => {
        plan.cobros.push({ concepto_pago_id: x.concepto_pago_id, monto: 0, cuotas: x.max_cuotas, xedit: false, xmax_cuotas: x.max_cuotas });
      });
      if (!this.programa.planes) this.programa.planes = [];
      if (!this.programa.planes.find(p => p.nombre == plan.nombre)) {
        this.programa.planes.push(plan);
        window.$('#collapseplanes').collapse('show');
      }
    },
    onGuardarCodigo(codigo) {
      this.codigo_contabilidad = codigo;
      this.guardarcodigoconta();
    },
  },

  beforeDestroy() { this.$store.state.show_rol_select = true; },

  async mounted() {
    this.$store.state.show_rol_select = false;
    this.modulos_obligatorios = false;
    this.getConveniosUniversidades();
    await this.getSedes();

    this.isdevmode = process.env.VUE_APP_GRAPHQL.includes('apidev');
    this.ispostgrado = true;

    const idrol = this.$store.state.CARGO.id;
    this.only_read_acade = ![1, 5, 6, 7, 8].includes(idrol);
    this.only_read_conta = ![1, 14, 15].includes(idrol);
    this.is_perm_benefi = [1, 6, 8, 14].includes(idrol);

    this.getconceptosdepago();

    const idprograma = window.localStorage.getItem('rest_idprograma');
    const xpostgrado = window.sessionStorage.getItem('xpostgradorest');

    if (idprograma) {
      this.verificarYaenviado(idprograma);
      this.getprogramabyid(idprograma);
      this.getpostitulos(idprograma);
      this.planesPordefecto();
    } else if (!xpostgrado) {
      this.$dialog.alert({ title: 'ALERTA:', body: 'No se pudo obtener un identificador del programa, vuelva a ingresar a esta pagina.' });
    } else {
      this.getsucs();
      const post = JSON.parse(xpostgrado);
      if ([1, 2, 3].includes(post.categoria.id)) this.modulos_obligatorios = true;
      this.xposgradin = post;
      post.nombre = post.nombre.replaceAll('Diplomado DIPLOMADO','DIPLOMADO')
      this.verificarYaenviado(post.id);
      this.programa = {
        nombre_compuesto: post.nombre, posgrado_id: post.id,
        nota_aprobacion: 71, version: 1, grupo: 1,
        gestion: new Date().getFullYear(),
        coordinador: {}, responsable: {},
        programa_modulo: [], planes: [],
        xcategoria_id: post.categoria.id,
      };
      this.universidadsel = this.$store.state.convenio;
      this.planesPordefecto();
    }
    this.cargar_modulos_universidad();
  },
};
</script>

<style scoped>
.programa-page { background: #f5f7fb; padding-bottom: 48px; }
.programa-card { border-radius: 16px; box-shadow: 0 10px 30px rgba(0,0,0,.08); overflow: hidden; }
.programa-body { background: #fff; }
</style>
